//https://swiperjs.com/
import Swiper from 'swiper';
import {Navigation,EffectFade,EffectCreative,A11y,FreeMode,Thumbs,Autoplay,Keyboard} from 'swiper/modules';

//import swiper styles
import 'swiper/css/bundle';

//Hero Slideshows
const heroSlides = document.querySelectorAll('.js-home-slideshow');
if( heroSlides ){

    heroSlides.forEach((hero, index) => {

        let slider = hero;
        let prev = hero.querySelector('.swiper-button-prev');
        let next = hero.querySelector('.swiper-button-next');
        let autoplaySpeed = slider.getAttribute('data-autoplay-speed') || 5000;
        let slidecount = slider.getAttribute('data-slide-count') || 1;
        let toggleBtn = hero.querySelector('.js-pause-slideshow');
        let isManuallyPaused = false;

        const heroGallery = new Swiper(slider, {
            modules: [Navigation,A11y,Autoplay,EffectCreative],
            loop: false, //looping true is not good for accessibility because it can cause focus to jump around unexpectedly for keyboard and screen reader users and causes transitions to be buggy
            speed: 1000,
            watchSlidesProgress: true,
            effect: "creative",
            creativeEffect: {
                perspective: true,
                prev: {
                    shadow: false,
                    translate: ["-50%", 0, -1],
                },
                    next: {
                    translate: ["100%", 0, 0],
                },
            },
            a11y: {
                enabled: true,
                containerRoleDescriptionMessage: 'carousel', 
                itemRoleDescriptionMessage: 'slide',
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                slideLabelMessage: '{{index}} of {{slidesLength}}',
            },
            autoplay:{
                delay: parseInt(autoplaySpeed, 10),
                disableOnInteraction: false,
                pauseOnMouseEnter: true,     // Pauses autoplay when a mouse hovers over it
            },
            navigation: {
                addIcons: false,
                nextEl: next,
                prevEl: prev,
            },
            breakpoints: {
                1024: {
                    speed: 1500,
                }
            },
            // COMPLIANCE FIX: Manually enforce ARIA attributes for the Fade Effect
            on: {
                init: function () {
                    enforceButtonAccessibility(prev, next);
                },
                slideChange: function () {
                    enforceButtonAccessibility(prev, next);
                },
                toEdge: function () {
                    enforceButtonAccessibility(prev, next);
                }
            }
        });

        const syncPauseButton = () => {
            toggleBtn.setAttribute('aria-label', isManuallyPaused ? 'Start automatic slideshow' : 'Pause automatic slideshow');
            toggleBtn.classList.toggle('is-paused', isManuallyPaused);
        };

        slider.addEventListener('focusin', () => {
            heroGallery.autoplay.stop();
        });

        slider.addEventListener('focusout', (e) => {
            const nextFocusedElement = e.relatedTarget;

            if( nextFocusedElement && slider.contains(nextFocusedElement) ){
                return;
            }

            if( !isManuallyPaused ){
                heroGallery.autoplay.start();
            }
        });

        // Pause/play slideshow on .js-pause-slideshow button click
        toggleBtn.addEventListener('click', () => {
            if (isManuallyPaused) {
                heroGallery.autoplay.start();
                isManuallyPaused = false;
            } else {
                heroGallery.autoplay.stop();
                isManuallyPaused = true;
            }

            syncPauseButton();
        });

        syncPauseButton();

    });
}

//INTERIOR GALLERY w/ THUMBNAILS
const galleries = document.querySelectorAll('.gallery');
if( galleries ){

    galleries.forEach((gallery, index) => {

        let slider = gallery.querySelector('.js-gallery-slides');
        let thumbs = gallery.querySelector('.js-gallery-thumbs');
        let prev = gallery.querySelector('.swiper-button-prev');
        let next = gallery.querySelector('.swiper-button-next');

        const galleryThumbs = new Swiper(thumbs, {
            modules: [FreeMode],
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesProgress: true,
        });

        const galleryTop = new Swiper(slider, {
            modules: [EffectFade,Navigation,A11y,Thumbs,Keyboard],
            loop: false,
            fadeEffect: { crossFade: true },
            effect: 'fade',
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            // COMPLIANCE FIX: This forces Swiper to track visibility 
            // and apply aria-hidden="true" to inactive slides
            watchSlidesProgress: true,
            a11y: {
                enabled: true,
                containerRoleDescriptionMessage: 'carousel',
                itemRoleDescriptionMessage: 'slide',
                slideLabelMessage: 'Slide {{index}} of {{slidesLength}}',
            },
            navigation: {
                addIcons: false,
                nextEl: next,
                prevEl: prev,
            },
            thumbs: {
                swiper: galleryThumbs,
            },
            // COMPLIANCE FIX: Manually enforce ARIA attributes for the Fade Effect
            on: {
                init: function () {
                    toggleSlideA11y(this);
                    enforceButtonAccessibility(prev, next);
                },
                slideChange: function () {
                    toggleSlideA11y(this);
                    enforceButtonAccessibility(prev, next);
                },
                toEdge: function () {
                    enforceButtonAccessibility(prev, next);
                }
            }
        });

    });
    
}

// COMPLIANCE FIX: Overrides Swiper's aggressive button lockout
function enforceButtonAccessibility(prevBtn, nextBtn) {
    // We use a tiny timeout to ensure our code runs right AFTER Swiper modifies the DOM
    setTimeout(() => {
        [prevBtn, nextBtn].forEach(button => {
            if (button) {
                // 1. Remove the native disabled attribute so focus isn't lost
                button.removeAttribute('disabled');
                
                // 2. Force the button back into the keyboard tab order
                button.setAttribute('tabindex', '0');
            }
        });
    }, 0);
}

// Helper function to handle the attribute swapping
function toggleSlideA11y(swiperInstance) {
    swiperInstance.slides.forEach(slide => {
        // Check if this specific slide is the active one
        if (slide.classList.contains('swiper-slide-active')) {
            slide.setAttribute('aria-hidden', 'false');
            slide.removeAttribute('tabindex'); // Accessible to screen readers/keyboards
        } else {
            slide.setAttribute('aria-hidden', 'true');
            slide.setAttribute('tabindex', '-1'); // Hidden from screen readers/keyboards
        }
    });
}